import { useNavigate } from 'react-router-dom'

import { Card } from '@/shared/components/ui/card'
import { getDashboardBarColor } from '@/shared/lib/dashboardProgress'
import { buildLeadFilterUrl } from '@/shared/lib/leadNavigation'

export default function CampaignLeadsCard({ data, period, customRange }) {
  const navigate = useNavigate()
  const content = data ?? {
    total: 0,
    subtitle: 'total leads · by source',
    sources: [],
  }

  const sources = content.sources ?? []

  const renderSources = (sourceList) => {
    if (sourceList.length === 0) {
      return (
        <p className="py-4 text-center text-xs text-slate-400">No data yet</p>
      )
    }

    return sourceList.map((source) => (
      <div
        key={source.name}
        onClick={(e) => {
          e.stopPropagation()
          navigate(
            buildLeadFilterUrl('/admin/leads', {
              source: source.name,
              period,
              customRange,
            }),
          )
        }}
        className="flex cursor-pointer items-center gap-2.5 rounded-lg p-1 transition-colors hover:bg-slate-50"
        title={`View ${source.name} leads`}
      >
        <span
          className="h-2 w-2 shrink-0 rounded-full"
          style={{
            backgroundColor: getDashboardBarColor(source),
          }}
        />

        <span className="text-xs font-semibold text-slate-700">
          {source.count}
        </span>

        <span className="text-xs text-slate-500">from {source.name}</span>
      </div>
    ))
  }

  return (
    <Card className="h-[260px] overflow-hidden rounded-2xl border border-black/[0.06] bg-white shadow-[0_8px_24px_rgba(15,23,42,0.04)] sm:rounded-[20px]">
      <div className="flex h-full flex-col p-4">
        {/* Total Leads Created */}
        <div
          className="cursor-pointer transition hover:opacity-80"
          onClick={() =>
            navigate(
              buildLeadFilterUrl('/admin/leads', { period, customRange }),
            )
          }
          title="View all leads"
        >
          <h3 className="text-sm font-semibold text-slate-900">
            Total Leads Created
          </h3>

          <div className="mt-2">
            <span className="text-[clamp(1.75rem,4vw,2.25rem)] font-extrabold leading-none tracking-tight text-slate-900">
              {content.total ?? 0}
            </span>
          </div>

          <p className="mt-1 text-[11px] text-slate-400">
            {content.subtitle || 'total leads created · by source'}
          </p>
        </div>

        {/* Sources List */}
        <div className="mt-2 min-h-0 flex-1 overflow-y-auto pr-1 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          <div className="space-y-1">{renderSources(sources)}</div>
        </div>
      </div>
    </Card>
  )
}
